/** Paras bill without goals, so an empty goal selection never blocks confirming their sessions. */
export const isConfirmBlockedByMissingGoals = ({
  goalsCount,
  isPara,
}: {
  goalsCount: number;
  isPara: boolean;
}): boolean => goalsCount === 0 && !isPara;
